import { Button } from '@artstorefronts/ui';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

import { cleanHtmlResponse } from '../utils';
import { useAnalytics } from '../context/analytics';

interface CopyButtonProps {
  text?: string;
  historyItem?: boolean;
  loading?: boolean;
  showText?: boolean;
  chatItem?: boolean;
}

function CopyButton({
  text,
  historyItem = false,
  loading = false,
  showText = true,
  chatItem = false,
}: CopyButtonProps) {
  const { t } = useTranslation('common');
  const { amplitude, intercom } = useAnalytics();

  return (
    <Button
      title={t('copy-to-clipboard')}
      type="button"
      variant="ghost"
      className={`h-auto text-xs px-2 py-1.5 rounded-md hover:text-gray-700 hover:bg-gray-100 transition-colors ${historyItem ? 'px-0 hover:bg-transparent' : ''}`}
      size="sm"
      onClick={(e) => {
        e.preventDefault();
        if (text) {
          const cleanedText = cleanHtmlResponse(text);
          navigator.clipboard.writeText(cleanedText);
          toast.success(t('copied-to-clipboard'));

          if (chatItem) {
            amplitude.track('chat_message_copied', {
              message: cleanedText,
            });
            intercom.trackEvent('chat_message_copied', {
              message: cleanedText,
            });
          }
        }
      }}
      disabled={loading}
    >
      <Copy className={`size-4 ${showText ? 'mr-1' : ''}`} />
      {showText && t('copy')}
    </Button>
  );
}

export default CopyButton;
